export * from './format';
export * from './bitwise';

export const isNumberString = (str: string): boolean => {
  return /^\d{1,}$/.test(str);
};
